import { GTM_LEADS_FLAG_KEY } from "../constants";

/**
 * Pure flag reader (story 11.2 / Epic 11). Not a paid-plan entitlement.
 * sessionStorage override: `gtm-leads:enabled` = `"1"` | `"0"`.
 * Default when unset: enabled (Phase A shells visible).
 */
export function readGtmLeadsFlag(): boolean {
  try {
    if (typeof window === "undefined") return true;
    const raw = window.sessionStorage.getItem(GTM_LEADS_FLAG_KEY);
    if (raw === "0") return false;
    if (raw === "1") return true;
  } catch {
    // ignore storage errors
  }
  return true;
}

export function useGtmLeadsFlag(): boolean {
  return readGtmLeadsFlag();
}
